import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

const CAROUSEL_SELECTOR = '.js-featured-carousel'
const PREV_BUTTON_SELECTOR = '.js-featured-carousel-prev'
const NEXT_BUTTON_SELECTOR = '.js-featured-carousel-next'
const OPTIONS = {
  autoplay: {
    delay: 3000,
  },
  loop: true,
  navigation: {
    nextEl: NEXT_BUTTON_SELECTOR,
    prevEl: PREV_BUTTON_SELECTOR
  },
  breakpoints: {
    500: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
}

export function initFeaturedCarousel() {
  if (!document.querySelector(CAROUSEL_SELECTOR)) {
    return
  }
  new Swiper(CAROUSEL_SELECTOR, { ...OPTIONS })
}
